import { BaseTool } from '../BaseTool';

export class IDSelectionTool extends BaseTool {
    id = 'MANAGE_ID_SELECTION';
    name = 'Select by ID';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openManageDialog('idSelection');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
